export const DASHBOARD_ILLUSTRATION_PATH = '/assets/illustrations/illustration-dashboard.webp';

export const HOME_CLEAN_IMAGE_PATH = '/assets/images/home/clean_5.webp';

export const HOME_HERO_LIGHT_1_IMAGE_PATH = '/assets/images/home/hero_light_1.webp';

export const HOME_HERO_LIGHT_2_IMAGE_PATH = '/assets/images/home/hero_light_2.webp';

export const SHARE_PROFILE_OVERLAY_IMAGE_PATH = '/assets/background/overlay_3.jpg';
